module.exports = __webpack_public_path__ + "img/LOGO.22a1ed44.png";